import React from 'react';

import { UiButton } from '../ui/ui-button';

const calendlyLink = 'https://calendly.com/d/gvs-ydy-fdr/hris-payroll-system-sync-setup';
export const CalendlyHyperlink = ({ text }: { text: string }) => (
  <a className="typo-link" href={calendlyLink} target="_blank" rel="noopener noreferrer">
    {text}
  </a>
);

type InputProps = {
  handlePrevious: () => void;
  handleClose: () => void;
};

export const HrisIntegrationResponseScheduleMeeting = ({
  handlePrevious,
  handleClose,
}: InputProps) => {
  const getSmartlookClickInfo = (action: string) => ({
    eventName: 'HRIS response dialog click',
    props: {
      component: 'schedule meeting',
      action,
    },
  });

  return (
    <>
      <div className="u-margin-top">
        We&apos;re excited to help you set up your HR/payroll sync!
      </div>
      <div className="u-margin-top">
        <CalendlyHyperlink text="Schedule a quick setup call" />
        &nbsp;with our Customer Success team to get started.
      </div>
      <div className="u-flex-center u-margin-top u-justifyContent-spaceBetween">
        <UiButton
          variant="tertiary"
          size="sm"
          onClick={handlePrevious}
          smartlookEvent={getSmartlookClickInfo('previous')}
        >
          Previous
        </UiButton>
        <UiButton
          variant="primary"
          size="sm"
          target="_blank"
          rel="noppen noreferrer"
          href={calendlyLink}
          onClick={handleClose}
          smartlookEvent={getSmartlookClickInfo('schedule setup')}
        >
          Schedule Setup
        </UiButton>
      </div>
    </>
  );
};
